import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../lib/adminApi";

const LOGO = "https://customer-assets.emergentagent.com/job_bf3d52d1-4f5f-47e0-aaa8-bb73dc6635d2/artifacts/m948yyw5_LOGO%20IBIALCON.png";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      nav("/admin", { replace: true });
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#070B19] text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-10">
          <div className="w-20 h-20 rounded-full bg-white/95 p-2 ring-1 ring-[#C9A961]/30 mb-4">
            <img src={LOGO} alt="IBIALCON" className="w-full h-full object-contain" />
          </div>
          <h1 className="font-[Playfair_Display] text-3xl tracking-wider">IBIALCON</h1>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#C9A961] mt-1">Panel Gerente</p>
        </div>

        <form onSubmit={onSubmit} className="bg-[#0D1424]/80 border border-[#C9A961]/30 p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#C9A961] mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full bg-transparent border-b border-[#C9A961]/30 focus:border-[#C9A961] text-white py-2 outline-none"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#C9A961] mb-2">Contraseña</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-[#C9A961]/30 focus:border-[#C9A961] text-white py-2 outline-none"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-red-400 text-sm border border-red-500/30 bg-red-500/10 p-3">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center px-8 py-4 uppercase tracking-[0.15em] text-sm font-semibold bg-[#C9A961] text-[#070B19] hover:bg-[#D4AF37] transition-all disabled:opacity-50"
          >
            {loading ? "Accediendo..." : "Entrar"}
          </button>

          <a href="/" className="block text-center text-xs uppercase tracking-[0.25em] text-white/50 hover:text-[#C9A961] transition-colors">← Volver al sitio</a>
        </form>
      </div>
    </div>
  );
}
